import { EndpointWithoutRequest, Http } from "Application";
import { AppUrls } from "AppUrls";

export class StudentResponse {
    public id: string = "";
    public firstName: string = "";
    public lastName: string = "";
}

export class GETStudentsEndpoint extends EndpointWithoutRequest<StudentResponse> {
    constructor() {
        super();
        this.verb(Http.Get);
        this.path(AppUrls.Server.Student.GetAllStudents);
    }

    public async HandleResponseAsync(responses: StudentResponse[]): Promise<StudentResponse[]> {
        return responses;
    }
}
